import React from "react";
import { useNavigate } from "react-router-dom";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  setUserid as setUseridAction,
  setPassword as setPasswordAction,
  setAuthFlg as setAuthFlgAction,
  setLoginMessage as setLoginMessageAction,
  selectUserid,
  selectPassword,
  selectAuthFlg,
  selectLoginMessage,
} from "../../features/authFormSlice";
// import { styled, Theme, createStyles,css } from  '@mui/material/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  TextField,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { auth, emailAndPasswordSignIn } from "../../firebase/firebase";
import { initialOperation } from "../../data/userInfo";
import { useAccessLog } from "../../accessLog/useAccessLog";

const root = css`
  height: 100vh;
  width: 100vw;
  background-color: #d7fff1;
`;
const card = css`
  height: 80vh;
  width: 120vw;
  margin: auto;
`;
const button = css`
  color: #fff;
  background-color: #1ba649;
  margin: 80px 0 0 auto;
  &:hover {
    background: #1ba649;
  }
`;
const errorMessage = css`
  color: red;
  margin-top: 10px;
  font-size: 13px;
  display: block;
  text-align: center;
`;

const invisibleMessage = css`
  height: 20px;
  margin-top: 10px;
`;

const Auth: React.FC = (props: any) => {
  const navigate = useNavigate();
  // Redux状態管理: useStateからReduxのuseAppSelectorに移行
  const dispatch = useAppDispatch();
  const userid = useAppSelector(selectUserid);
  const password = useAppSelector(selectPassword);
  const authFlg = useAppSelector(selectAuthFlg);
  const loginMessage = useAppSelector(selectLoginMessage);

  // アクセスログを自動送信
  useAccessLog();

  const signIn = async () => {
    let inputUserId: string = userid;
    if (inputUserId.indexOf("@") === -1) {
      // 「@」が含まれない場合は「@opview.7view.jp」を付与する
      inputUserId = userid + "@opview.7view.jp";
    }
    try {
      await emailAndPasswordSignIn(auth, inputUserId, password);
      // Redux: ログインメッセージを更新
      dispatch(setLoginMessageAction("ログインに成功しました"));
      // ログイン画面からアクセスしたときのユーザー情報取得
      await initialOperation();
      navigate("/home");
    } catch (error: any) {
      // Redux: 認証フラグとメッセージを更新
      dispatch(setAuthFlgAction(false));
      if (error.code === "auth/wrong-password") {
        dispatch(setLoginMessageAction("パスワードが違います"));
      } else if (error.code === "auth/invalid-email") {
        dispatch(setLoginMessageAction("登録されていないIDです"));
      } else {
        dispatch(setLoginMessageAction("ログインに失敗しました"));
      }
      console.log(error.code);
      console.log(error.message);
    }
  };

  // 本番環境以外ではログイン画面を表示する
  const isProduction = process.env.REACT_APP_MODE === "production" || process.env.REACT_APP_MODE === "prod" || process.env.REACT_APP_MODE === "cloud-prod";
  const isAuthDisplay: boolean = !isProduction; // 本番環境以外でログイン画面を表示


  return (
    <Grid container css={root} justifyContent="center">
      <Grid container item xs={12} md={10} lg={8} xl={6}>
        {isAuthDisplay ? (
          <Card css={card}>
            <CardHeader title="OFCダッシュボード" />
            <Grid container justifyContent="center">
              <img
                src={`${window.location.origin}/image/sejlogo.png`}
                alt="SEJアイコン"
                style={{ height: "15vh" }}
              />
            </Grid>
            <CardContent>
              <Grid container justifyContent="center">
                <TextField
                  margin="dense"
                  required
                  label="ユーザーID"
                  variant="outlined"
                  style={{ width: "72vw" }}
                  id="userid"
                  name="userid"
                  autoComplete="userid"
                  value={userid}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    // Redux: ユーザーIDを更新
                    dispatch(setUseridAction(e.target.value));
                  }}
                />
                <TextField
                  margin="dense"
                  required
                  label="パスワード"
                  type="password"
                  variant="outlined"
                  style={{ width: "72vw" }}
                  name="password"
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    // Redux: パスワードを更新
                    dispatch(setPasswordAction(e.target.value));
                  }}
                />
              </Grid>
              <Typography css={!authFlg ? errorMessage : invisibleMessage}>
                {loginMessage}
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                size="large"
                variant="contained"
                css={button}
                onClick={async () => {
                  try {
                    await signIn();
                  } catch (err) {
                    console.log(err);
                  }
                }}
              >
                ログイン
              </Button>
            </CardActions>
          </Card>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
};

export default Auth;
